import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Input, Typography, Select, Form, Upload, message, Space } from 'antd';
import { PlusOutlined, UploadOutlined, GlobalOutlined } from '@ant-design/icons';
import fileService from '../services/fileService';
import apiClient from '../services/api';

const { Text } = Typography;
const { Option } = Select;

console.log('CreateNoteTest loaded');

function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name) || '';
}

const CreateNoteTest = ({ onNoteCreated }) => {
  const [form] = Form.useForm();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFileUrls, setUploadedFileUrls] = useState([]);
  const [createNoteKnowledgeBase, setCreateNoteKnowledgeBase] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [availableKnowledgeBases, setAvailableKnowledgeBases] = useState([]);

  // 自动获取token和userId
  const token = getQueryParam('token');
  const userId = getQueryParam('userId');

  useEffect(() => {
    // 自动拉取知识库数据
    async function fetchKBs() {
      try {
        // 设置token到apiClient
        if (token) {
          apiClient.defaults.headers['Authorization'] = `Bearer ${token}`;
        }
        // 假设有 /users/knowledge-bases 接口
        const res = await apiClient.get(`/users/${userId}/knowledge-bases`);
        setAvailableKnowledgeBases(res.data.data || res.data || []);
      } catch (err) {
        message.error('Failed to fetch knowledge bases: ' + (err.message || ''));
      }
    }
    if (token && userId) fetchKBs();
  }, [token, userId]);

  const handleFileChange = ({ fileList }) => {
    setSelectedFiles(fileList.map(f => f.originFileObj).filter(Boolean));
  };

  const handleKnowledgeBaseChange = (kbId) => {
    const kb = availableKnowledgeBases.find(k => k.kb_id === kbId);
    setCreateNoteKnowledgeBase(kb);
  };

  const handleFinish = async (values) => {
    setIsCreating(true);
    let sourceUrl = values.url || '';
    let sourceType = 'PDF';
    let fileUploadResult = null;
    let urls = [];

    if (selectedFiles && selectedFiles.length > 0) {
      try {
        fileUploadResult = await fileService.uploadMultipleFiles(selectedFiles, 'document');
        urls = (fileUploadResult.success || []).map(item => item.url);
        if (urls.length > 0) {
          sourceUrl = urls[0];
          sourceType = 'URL';
          setUploadedFileUrls(urls);
        } else {
          message.error('File upload failed, no valid URL obtained');
          setIsCreating(false);
          return;
        }
      } catch (err) {
        message.error('File upload failed: ' + (err.message || 'Unknown error'));
        setIsCreating(false);
        return;
      }
    }

    const createData = {
      ...values,
      url: sourceUrl || '',
      source_type: sourceType,
      kb_id: createNoteKnowledgeBase?.kb_id || null
    };

    // 这里可以调用后端API创建笔记
    // await api.createNote(createData);
    message.success('Note creation simulated successfully!');
    setIsCreating(false);
    if (onNoteCreated) onNoteCreated(createData);
  };

  return (
    <div style={{ maxWidth: 600, margin: '40px auto', background: '#fff', padding: 32, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <Typography.Title level={4} style={{ marginBottom: 24 }}>
        <GlobalOutlined style={{ marginRight: 8, color: '#667eea' }} />Link/File Create Note Test Page
      </Typography.Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
      >
        <Form.Item
          name="url"
          label="URL"
          rules={[{ required: false, message: 'Please enter a URL' }]}
        >
          <Input placeholder="Enter a web link, or upload a file" />
        </Form.Item>
        <Form.Item label="Upload File">
          <Upload
            beforeUpload={() => false}
            fileList={selectedFiles.map((file, idx) => ({
              uid: idx,
              name: file.name,
              status: 'done',
              originFileObj: file
            }))}
            onChange={handleFileChange}
            multiple
            showUploadList
            accept=".txt,.md,.pdf,.doc,.docx"
          >
            <Button icon={<UploadOutlined />}>Select Files to Upload</Button>
          </Upload>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Supports TXT, MD, PDF, DOC, DOCX formats, up to 5 files
          </Text>
        </Form.Item>
        <Form.Item label="Knowledge Base" required>
          <Select
            placeholder="Select knowledge base"
            value={createNoteKnowledgeBase?.kb_id}
            onChange={handleKnowledgeBaseChange}
            allowClear
            loading={availableKnowledgeBases.length === 0}
          >
            {availableKnowledgeBases.map(kb => (
              <Option key={kb.kb_id} value={kb.kb_id}>
                {kb.is_private ? 'Private KB' : 'Collaborative KB'} - {kb.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item style={{ textAlign: 'right' }}>
          <Space>
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />} loading={isCreating}>
              Create Note
            </Button>
          </Space>
        </Form.Item>
      </Form>
      {uploadedFileUrls.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Text type="secondary">Uploaded file URLs:</Text>
          <ul>
            {uploadedFileUrls.map(url => (
              <li key={url}>
                <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CreateNoteTest; 